export default __webpack_public_path__ + "static/media/fish.3bddbf94.svg";